import styled from 'styled-components'
import { ASSETS } from '../../../constants/assets'
import { setPaddingSize } from '../../../utils/contentfulStyles.utils'

export const KeyStatsContainer = styled.div<{
  $background: string
  $topPadding: string
  $bottomPadding: string
  $homePageBg: boolean
  $isCustomerStory: boolean
  $useCase?: string
}>`
  position: relative;
  z-index: 1;

  ${({
    theme,
    $background,
    $topPadding,
    $bottomPadding,
    $homePageBg,
    $isCustomerStory,
    $useCase,
  }) => {
    let greyBg = ``
    let themeStyles = ``
    let paddingStyles = `
      padding-top: ${setPaddingSize($topPadding)}px;
      padding-bottom: ${setPaddingSize($bottomPadding)}px;
    `

    if ($homePageBg && $background === 'Grey') {
      greyBg = `background: ${theme.webMktNewPalette.deepBlue[10]};`
    } else {
      greyBg = ``
    }

    if ($background === 'Dark') {
      themeStyles += `
        background: ${theme.webMktNewPalette.deepBlue[70]};
       

        h6, p, h2 {
          color:${theme.webMktNewPalette.white};
        }

        .KeyStats__Number:before {
          border-bottom: 12px solid ${theme.webMktPalette.blue[80]};
        }

        .KeyStats__FinePrint {
          color: ${theme.webMktNewPalette.alphaWhite[30]};
          
        }
        .KeyStats__Source{       
          color:${theme.webMktNewPalette.white};
        }
      `
    } else if ($background === 'Grey') {
      themeStyles += `
        h6, p, h2 {
          color: ${theme.webMktNewPalette.white};
        }

        .KeyStats__Number:before {
          border-bottom: 12px solid ${theme.webMktPalette.blue[80]};
        }

        .KeyStats__Inner-Container .KeyStats__Item {
          background: ${theme.webMktNewPalette.deepBlue[70]};
        }

        .KeyStats__Source{       
          color:${theme.webMktNewPalette.white};
        }
      `
    } else {
      themeStyles += `
        ${
          $useCase === 'Events' &&
          `background:url(${ASSETS.KEYSTATS_FEATURED_EVENT}); background-size: cover; background-position: center; background-repeat: no-repeat; background-position: top center;`
        }

        ${theme.breakpoints.down('sm')} {
          ${$useCase === 'Events' && `background-size: contain;`}
        }

        @media (max-width: 767px) {
          background: none;
        }

        h6, p {
          color: ${theme.webMktNewPalette.black};
        }

        .KeyStats__Number:before {
          border-bottom: 12px solid ${theme.webMktPalette.cyan[20]};
        }

        .KeyStats__Source{       
          color:${theme.webMktNewPalette.alphaBlack[30]};
        }
      `
    }

    themeStyles +=
      $background !== 'Grey' && !$isCustomerStory
        ? ` 
        .KeyStats__Item{
        display:flex;
        flex-direction:column;
        row-gap:24px;
        justify-content:space-between;
         ${theme.breakpoints.down('md')} {
         row-gap:0;
         }
         ${theme.breakpoints.down('sm')} {
          row-gap:18px;
          }
          .upper__item{
          position:relative;
          height:272px;
          ${theme.breakpoints.down('md')} {
            min-height:248px;
            height:auto;
          }
           ${theme.breakpoints.down('sm')} {
             min-height:212px;
             height:auto;
           }
          }
        }.upper__item:before {
          content: '';
          position: absolute;
          z-index: -1;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          background-image: radial-gradient(#9c9c9c 1px, transparent 0);
          background-repeat: repeat;
          background-size: 24px 24px;
          background-position: right top;
        }
        .bottom__item{
        min-height:50px;
        }  
      `
        : ''

    if ($background !== 'Dark')
      themeStyles += `
        .KeyStats__FinePrint {
          color:${theme.webMktNewPalette.alphaBlack[30]};
        }
      `

    //* DETERMINE STYLES BASED ON PAGE TYPE
    let innerContainerStyles = ``
    if ($isCustomerStory) {
      innerContainerStyles = `
        padding-bottom: 64px;

        .KeyStats__Inner-Container {
          grid-template-columns: repeat(5, minmax(0, 1fr));

          ${theme.breakpoints.down('sm')} {
            grid-template-columns: repeat(3, minmax(0, 1fr));
            grid-row-gap: 20px;
          }

          ${theme.breakpoints.down('xs')} {
            grid-row-gap: 24px;
            margin-right: auto !important;
            margin-left: 0 !important;
          }
        }

        .KeyStats__Text {
          padding: 0;
          color: ${theme.webMktNewPalette.deepBlue[55]};
        }

        .KeyStats__Item {
          text-align: left;
        }

        .KeyStats__Number {
          margin-top: 6px;

          &:before {
            bottom: 3px;
          }

          ${theme.breakpoints.down('md')} {
            &:before {
              bottom: 4px;
            }
          }
        }

        .KeyStats__UpperText {
          margin-top: 16px;
          margin-bottom: 0;

          ${theme.breakpoints.down('md')} {
            margin-top: 6px;
          }
        }

        .KeyStats__Text {
          margin-top: 30px;

          ${theme.breakpoints.down('sm')} {
            margin-top: 14px;
          }
        }
      `
    } else {
      innerContainerStyles = `
        ${paddingStyles}
        .KeyStats__Inner-Container {
          grid-template-columns: repeat(3, minmax(0, 1fr));

          ${theme.breakpoints.down('sm')} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            grid-row-gap: 24px;
          }
        }
        
        .KeyStats__Text {
          padding: 0 24px;
        }

        .KeyStats__Number {
          margin-top: 64px;
          

          &:before {
            bottom: 12px;
          }
          
          ${theme.breakpoints.down('sm')} {
          

            &:before {
              bottom: 8px;
            }
          }
          ${theme.breakpoints.down('xs')} {
            margin-top: 48px;
           
          }          
        }

        .KeyStats__Item {
          text-align: center;
          min-height: 272px;

          ${theme.breakpoints.down('md')} {
            min-height: 248px;
          }

          ${theme.breakpoints.down('sm')} {
            min-height: 212px;
            height:auto;

          }
        }

        .KeyStats__UpperText {
          margin-top: 38px;
          margin-bottom: 0;
 ${theme.breakpoints.down('sm')} {
  margin-top: 26px;
 }
          
        }

        .KeyStats__Text {
          margin-top: 16px;

          ${theme.breakpoints.down('sm')} {
            margin-top: 8px;
          }
        }
      `
    }

    return `
      ${themeStyles}
      ${innerContainerStyles}
      ${greyBg}
    `
  }}

  .KeyStats__Inner-Container {
    display: grid;
    grid-column-gap: 24px;

    ${({ theme }) => theme.breakpoints.down('sm')} {
      max-width: 748px;
      margin: 0 auto;
      grid-column-gap: 16px;
    }

    ${({ theme }) => theme.breakpoints.down('xs')} {
      max-width: 328px;
      grid-template-columns: repeat(1, minmax(100%, 1fr));
    }
  }

  .KeyStats__FinePrint {
    max-width: 791px;

    text-align: center;
    margin: 32px auto 0;
  }

  .KeyStats__Item {
    position: relative;

    .KeyStats__UpperText {
      display: block;

      & + .KeyStats__Number {
        margin-top: 2px;
      }
    }

    .KeyStats__Number {
      display: inline-block;
      margin-bottom: 0;
      position: relative;
      z-index: 1;

      &:before {
        content: '';
        position: absolute;
        width: 100%;
        left: 0;
        z-index: -1;
      }

      ${({ theme }) => theme.breakpoints.down('md')} {
        &:before {
          border-width: 8px;
        }
      }
    }
  }

  .KeyStats__Outer-Container-Events {
    max-width: 1584px;
    margin: 0 auto;
    padding: 0;

    ${({ theme }) => theme.breakpoints.down('lg')} {
      margin: 0 32px;
    }
    ${({ theme }) => theme.breakpoints.down('xs')} {
      margin: 0 24px;
    }

    @media (max-width: 767px) {
      margin: 0 16px;
    }

    .KeyStats__Inner-Container-Events {
      display: flex;
      justify-content: space-between;
      position: relative;
      align-items: center;
      ${({ theme }) => theme.breakpoints.down('sm')} {
        flex-direction: column;
      }

      .KeyStats__Container {
        display: flex;
        justify-content: space-between;
        position: absolute;
        width: 100%;
        ${({ theme }) => theme.breakpoints.down('sm')} {
          position: relative;
          order: 2;
          justify-content: center;
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          margin: 0 auto;
        }

        @media (max-width: 767px) {
          flex-direction: column;
          max-width: 328px;
        }

        .upper__item {
          :before {
            background-image: none;
          }
        }

        .KeyStats__Item {
          margin-bottom: 32px;
          &:last-child {
            margin-bottom: 0;
            @media (max-width: 767px) {
              margin-bottom: 32px;
            }
          }
          ${({ theme }) => theme.breakpoints.down('md')} {
            margin-bottom: 24px;
          }
          @media (max-width: 767px) {
            margin-bottom: 32px;
          }
          .KeyStats__Number {
            ${({ theme }) => theme.breakpoints.down('md')} {
            }
            ${({ theme }) => theme.breakpoints.down('xs')} {
            }
          }
          .KeyStats__Text {
            ${({ theme }) => theme.breakpoints.down('sm')} {
            }
          }
        }
      }

      .KeyStats__Left {
        max-width: 378px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          width: 286px;
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          width: 352px;
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          width: 100%;
        }
      }

      .KeyStats__Right {
        max-width: 378px;
        ${({ theme }) => theme.breakpoints.down('md')} {
          width: 286px;
        }
        ${({ theme }) => theme.breakpoints.down('sm')} {
          width: 352px;
        }
        ${({ theme }) => theme.breakpoints.down('xs')} {
          width: 100%;
        }
      }

      .KeyStats__Featurd-Image {
        margin: 0 auto;
        order: 1;

        ${({ theme }) => theme.breakpoints.down('sm')} {
          margin-bottom: 32px;
        }

        img {
          border-radius: 50%;
          width: 720px;
          height: 720px;
          object-fit: cover;
          object-position: center;

          ${({ theme }) => theme.breakpoints.down('lg')} {
            width: 480px;
            height: 480px;
          }
          ${({ theme }) => theme.breakpoints.down('xs')} {
            width: 468px;
            height: 468px;
          }
          @media (max-width: 767px) {
            width: 328px;
            height: 328px;
          }
        }
      }
    }
  }
`
